/**
 * src/plugins/analytics.js
 *
 * Vue 3 plugin that registers AnalyticsService as $analytics globally.
 *
 * Tracks user-experience events only — page views, clicks, form submissions,
 * auth flows, and UX failures (Vue component errors).
 *
 * DO NOT add unhandledrejection listener here — promise rejections are
 * technical errors (JS crashes), not user-usage signal.
 */

import AnalyticsService from '@/services/AnalyticsService'

export default {
  install: (app) => {
    // window.$analytics for non-Vue contexts (vanilla JS modules, event handlers)
    window.$analytics = AnalyticsService

    // $analytics available in all Vue components via this.$analytics
    app.config.globalProperties.$analytics = AnalyticsService

    // Vue component errors — tracked as usage (UX failure events).
    // User-visible breakage, not a JS crash. These ARE usage signal.
    // Unhandled promise rejections: not tracked here — those are JS crashes.
    app.config.errorHandler = (err, instance, info) => {
      AnalyticsService.trackError('vue-error', err.message, {
        component: instance?.$options?.name,
        info
      })
    }
  }
}
